import React, { Component } from 'react';
import './index.css';

class AboutSection extends Component {
  render() {
    return (
      <section className="section aboutSection" id="aboutSection">
        <h2 className="section__title aboutSection__name">About</h2>
        <article className="section__content aboutSection__content">
        <img src="assets/me.jpeg" alt="Talita Oliveira" className="aboutSection__photo" />
          <p>
              Hello!! My name is <strong className="content__important">Talita Oliveira</strong>, I am a <strong className="content__important">Software Engineer</strong> currently living in <strong className="content__important">Germany - Berlin</strong>.
            </p>
        </article>
      </section>
    );
  }
}

export default AboutSection;